import React, { useEffect, useState } from "react";
import Header from "../Layouts/Header";
import axios from "axios";
import { API_URL, BASE_URL, PASSWORD, USERNAME } from "../../constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import Sidebar from "../Layouts/Sidebar";
import {
  getApiAction,
  getSiteId,
  postApiAction,
  productAddedMain
} from "../../Utils/helper";
import Slider from "react-slick";
import { useDispatch } from "react-redux";
import { decrementCartCount, incrementCartCount } from "../../store/action";
import ComplementryProducts from "./ComplementryProducts";
import SimilarProductItems from "./SimilarProductItems";

const ProductDetails = () => {
  const { id: product_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/submenu_Bg.png)`,
  };
  const [productId, setProductId] = useState(product_id);

  const [responseData, setResponseData] = useState(null);
  const [subCatResponseData, setSubCatResponseData] = useState(null);
  const [showComplementry, setShowComplementry] = useState(false);
  const [complementryitem, setComplementryItem] = useState(null);
  
  const [isProductAdded, setIsProductAdded] = useState(false);

  const sliderSettings = {
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
  };

  const complementrysliderSettings = (count) => {
    return  {
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 1500,
    slidesToShow: count >= 4 ? 4 : count,
    slidesToScroll: 1,
    arrows: true,
  }
};

  const [quantity, setQuantity] = useState(0);

  useEffect(() => {
    return () => {
      setProductId(product_id);
      const fetchData = async () => {
        try {
          let response = await getApiAction(
            "products/details?product_id=" + product_id,
            {},
            0,
            dispatch
          );
          setResponseData(response?.products);
          const cartValue =
            response?.products.cart_value &&
            response?.products.cart_value.length > 0
              ? response?.products.cart_value[0].quantity
              : 0;
          setQuantity(cartValue);
          if (response?.products?.category_id) {
            let subCatResponse = await getApiAction(
              "products?category_id=" + response?.products?.category?.name+'&product_id='+response?.products?.id,
              {},
              0,
              dispatch
            );
            setSubCatResponseData(subCatResponse?.products);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    };
  }, [product_id]);

  const [comment, setComment] = useState("");
  const [attribute_id, setAttributeId] = useState(0);
  const [modifier_id, setModifierId] = useState('');
  const [error, setError] = useState('');
  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const closePopup = () => {
    setShowComplementry(false);
  };

  const setShowComplementryFunction = (open, compitem) => {
    setShowComplementry(open);
    setComplementryItem(compitem)
  }

  const productAddHandleClick = async (name,productId,price,comment) => {
      let resp = await productAddedMain(
        name,
        productId,
        price,
        comment,
        attribute_id,
        modifier_id,
        dispatch
      );
      if(resp?.response?.data?.message){
        setError(resp.response.data.message)
      }else{
        setError('')
        setQuantity(1);
      }
      
  };

  const chooseVariety = (attribute_id, modifier_id) => {
    setAttributeId(attribute_id)
    setModifierId(modifier_id)
  };

  return (
    <div>
      <div className="wrapper">
        {/* <!-- START category_wrapper --> */}
        <div className="category_wrapper" style={bannerStyle}>
          {/* <!-- START headerSite --> */}
          <Header />
          {/* <!-- END headerSite --> */}
          <div className="pageContainer">
            <Sidebar />
            {/* <!-- START category_ContentArea --> */}
            <div className="category_ContentArea sub_categoryPart platilloContentPart">
            <div className="sub_categoryBox">
              {responseData && (
                <>
                  <h2>{responseData.name}</h2>
                  <div className="detailcategoryBox">
                    <div className="detailcategory_item">
                      <div className="larg_image">
                        <img
                          src={responseData.default_image}
                          alt=""
                        />
                      </div>
                      <div className="subText d-flex flex-wrap justify-content-between">
                        <div className="text">
                          <p>
                            {(responseData.description)?.split('~')[0]} 
                          <span className="indegrient">{((responseData.description)?.split('~')[1])?.split('#')[0] || ''}</span>
                          <span className="calories">{((responseData.description)?.split('~')[1])?.split('#')[1] || ''}</span>
                          </p>
                        </div>
                        <div className="quantity-box">
                        {(responseData?.complements.length && !attribute_id) ? (
                          <button
                              href="#"
                              className="addBtn disabled"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                              >
                                <path
                                  d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z"
                                  fill="white"
                                ></path>
                              </svg>
                              <span>
                              ${((Math.round(responseData.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                                <sup>{((Math.round(responseData.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                                </span>
                            </button>
                          ) : (
                            <button
                              href="#"
                              className="addBtn"
                              onClick={() => productAddHandleClick(responseData?.name,parseInt(productId, 10),responseData?.price,comment)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                              >
                                <path
                                  d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z"
                                  fill="white"
                                ></path>
                              </svg>
                              <span>
                              ${((Math.round(responseData.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                                <sup>{((Math.round(responseData.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                                </span>
                            </button>
                          )}
                              
                          {/*(quantity && (
                            <div className="number">
                              <span
                                className="minus"
                                onClick={() => decrementQuantity(responseData.id,quantity,comment)}
                              >
                                {quantity > 1 ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M4.16699 10.8337H15.8337V9.16699H4.16699V10.8337Z"
                                      fill="#1A4988"
                                    />
                                  </svg>
                                ) : (
                                  <>
                                  { <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M13.3337 7.5L13.3337 15.8333L6.66699 15.8333L6.66699 7.5L13.3337 7.5ZM12.0837 2.5L7.91699 2.5L7.08366 3.33333L4.16699 3.33333L4.16699 5L15.8337 5V3.33333L12.917 3.33333L12.0837 2.5ZM15.0003 5.83333L5.00033 5.83333L5.00033 15.8333C5.00033 16.75 5.75033 17.5 6.66699 17.5H13.3337C14.2503 17.5 15.0003 16.75 15.0003 15.8333L15.0003 5.83333Z"
                                      fill="#1A4988"
                                    />
                                  </svg> }
                                  </>
                                )}
                              </span>
                              <input type="text" value={quantity} />
                              <span
                                className="plus"
                                onClick={() => incrementQuantity(responseData.id,quantity,comment)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                >
                                  <path
                                    d="M15.8337 10.8337L10.8337 10.8337L10.8337 15.8337H9.16699L9.16699 10.8337H4.16699L4.16699 9.16699H9.16699V4.16699L10.8337 4.16699V9.16699L15.8337 9.16699V10.8337Z"
                                    fill="#1A4988"
                                  />
                                </svg>
                              </span>
                            </div>
                          )) || (
                            <span>
                            <button
                              href="#"
                              className="addBtn"
                              onClick={() => productAddHandleClick(responseData?.name,parseInt(productId, 10),responseData?.price,comment)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                viewBox="0 0 48 48"
                                fill="none"
                              >
                                <path
                                  d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z"
                                  fill="white"
                                ></path>
                              </svg>
                              <span>${responseData.double_digit_price}</span>
                            </button>
                            </span>
                          )*/}
                        </div>
                      </div>
                      <div className="comentBox">
                        <textarea
                          name=""
                          id=""
                          className="text_coment"
                          placeholder="Comentarios adicionales"
                          value={comment}
                          onChange={handleCommentChange}
                        ></textarea>
                        <div className="error">{error}</div>
                      </div>
                    </div>
                  </div>
               </>
              )}

              {(responseData?.complements.length) ? (
              <>
                {responseData?.complements?.map((option1) =>
                <div className="select_milkContent milkContentArea">
                  <h3>{option1.name}:</h3>
                  <Slider {...complementrysliderSettings(option1?.products.length)} className="milk_slider">
                  
                  {option1?.products?.map((item) => (
                    <>
                    {item?.modifier_options.length ? (
                      <>
                      {item?.modifier_options?.map((option) =>
                        <div className="milk_slide_item" >
                        <div className={"milk_item "+(attribute_id == item.id && modifier_id == option.productModifierID ? 'active' : '')}>
                          <div className="subText" 
                          onClick={() =>
                            chooseVariety(item.id, option.productModifierID)
                          }
                          >
                              <div className="image">
                                  <img src={item.default_image} alt={item.name}/>
                              </div>
                              <div className="text d-flex justify-content-between">
                                  <h4>{item.name}</h4>
                                  <div className="right">
                                      <span className="dollar_value">+ 
                                      ${((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                                      <sup>{((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                                      </span>                                                               
                                  </div>
                              </div>
                              <p>{option.optionName}</p>
                          </div>
                      </div>
                      </div>
                    )}

                    </>
                    ) : (
                    <>
                    <div className="milk_slide_item" >
                    <div className={"milk_item "+(attribute_id == item.id && modifier_id == 0 ? 'active' : '')}>
                          <div className="subText" 
                          onClick={() =>
                            chooseVariety(item.id, 0)
                          }
                          >
                              <div className="image">
                                  <img src={item.default_image} alt={item.name}/>
                              </div>
                              <div className="text d-flex justify-content-between">
                                  <h4>{item.name}</h4>
                                  <div className="right">
                                      <span className="dollar_value">+ 
                                      ${((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[0]}
                                      <sup>{((Math.round(item.double_digit_price * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                                      </span>                                                               
                                  </div>
                              </div>
                          </div>
                      </div>
                      </div>
                    </>
                    )}


                      </>
                    ))}

                  </Slider>
                </div>
              )}
              </>
              ) : (<></>)}

            </div>

            


              {subCatResponseData?.data?.length ? (
                <>
                {/* <!-- START other_similarBox --> */}
                <div className="other_similarBox">
                  <h3>Otros platillos similares:</h3>
                  {/* <div className="dishes_Slide"> */}
                  {showComplementry && (
                    <ComplementryProducts
                      itemData={complementryitem}
                      closePopup={closePopup}
                    />
                  )}
                  <Slider {...sliderSettings} className="dishes_Slide">
                    {subCatResponseData?.data?.map((item, index) => (
                      <SimilarProductItems item={item} setShowComplementryFunction={setShowComplementryFunction} />
                    ))}
                  </Slider>
                  
                  {/* </div> */}
                </div>
                {/* <!-- END other_similarBox --> */}
                </>
              ) : (
                <></>
              )}
            </div>
            {/* <!-- END category_ContentArea --> */}
          </div>
        </div>
        {/* <!-- END category_wrapper --> */}
      </div>

      {/*showComplementry && (
        <ComplementryProducts
          itemData={responseData}
          closePopup={closePopup}
        />
      )*/}
    </div>
  );
};

export default ProductDetails;
